export const EVENTS_OPTIONS = [
	{
		label: 'Page View',
		value: 'PAGE_VIEW',
	},
	{
		label: 'Lead',
		value: 'LEAD',
	},
];

export const TARGET_EVENTS_OPTIONS = [
	{
		label: 'Page View',
		value: 'PAGE_VIEW',
	},
	{
		label: 'Lead',
		value: 'LEAD',
	},
	{
		label: 'Paid',
		value: 'PAID',
	},
	{
		label: 'Delivered',
		value: 'DELIVERED',
	},
];
